<template>
    <div class="container">
        <md-dialog :md-active.sync="modModElimAct" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }}
            </md-dialog-title>
            <md-dialog-content>
                <b-row class="mt-3">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.valorAdicion}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="valAdicion" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.valorRetiro}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="valRetiro" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="d-flex col-12 justify-content-end">
                    <md-button class="md-primary" @click="guardarAddRet()">{{ labels.save }}</md-button>
                    <md-button class="md-accent" @click="quitaActivo()">{{ labels.quitar }}</md-button>
                    <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                </b-row>
            </md-dialog-content>
        </md-dialog>
        <InacticaItem :InactivaItem="showAdvQuitAct" @confirmDelete="confirmInactivate" @cierraModal="cierraModalAdv"></InacticaItem>
    </div>
</template>

<script>
import InacticaItem from '../utils/InacticaItem.vue'
import Activos from '../../services/Activos'

export default {
    name : 'ModModifiElimAct',
    props : ['modModElimAct','numActivo','nroContrato'],
    components : {
        InacticaItem
    },
    data : () => ({
        valAdicion : 0,
        valRetiro : 0,
        showAdvQuitAct : false
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Adición o retiro',
                    valorAdicion : 'Valor adición:',
                    valorRetiro : 'Valor retiro:',
                    quitar : 'Quitar',
                    save : 'Guardar',
                    close : 'Cerrar'
                }
            }else{
                return {
                    title : 'Addition or withdrawal',
                    valorAdicion : 'Added value:',
                    valorRetiro : 'Withdrawal value:',
                    quitar : 'Remove',
                    save : 'Save',
                    close : 'Close'
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        cierraModalAdv(){
            this.showAdvQuitAct = false
        },
        quitaActivo(){
            this.showAdvQuitAct = true
        },
        confirmInactivate(){
            const info = {
                'activo' : this.numActivo,
                'numContrato' : this.nroContrato,
                'idUser' : this.$store.state.userId
            }

            Activos.quitarActivoAlContrato(info)
            .then((res) => {
                // console.log(res.data);
                if (res.status == 200) {
                    this.$toast.success(res.data.message);
                    this.$router.push('modificarcontrato');
                    location.reload();
                }
            })
            .catch((error) => {
                if (error.response && error.response.data) {
                    this.$toast.error(error.response.data.message);
                }
            })
        },
        guardarAddRet(){
            const info = {
                activo : this.numActivo,
                valor_adicion : this.valAdicion,
                valor_retiro : this.valRetiro,
                idUser : this.$store.state.userId
            }

            Activos.mejoraRetiro(info)
            .then((res) => {
                if (res.status == 200) {
                    this.$emit('refreshTblModAct')
                    this.modModElimAct = false
                    this.limpiaInp()
                    this.$toast.success(res.data.message);
                }
            })
            .catch((error) => {
                if (error.status == 500) {
                    this.$toast.error(error.response.data.message);
                }
            })
        },
        limpiaInp(){
            this.valAdicion = 0
            this.valRetiro = 0
        }
    }
}
</script>

<style>

</style>